module.exports = __webpack_public_path__ + "assets/img/eml.f6897426.svg";